
import { BlogPost } from '../types';
import { tritonusPost } from './tritonussubstitution';
import { improvisationPost } from './improvisation';

// Combine all advanced posts
export const advancedPosts: BlogPost[] = [
  tritonusPost,
  improvisationPost
];
